import { render, staticRenderFns } from "./AgreementDialog.vue?vue&type=template&id=20f59dd0&scoped=true"
import script from "./AgreementDialog.vue?vue&type=script&lang=js"
export * from "./AgreementDialog.vue?vue&type=script&lang=js"
import style0 from "./AgreementDialog.vue?vue&type=style&index=0&id=20f59dd0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "20f59dd0",
  null
  
)

export default component.exports